
import React, { createContext, useMemo } from 'react'

import useMediaQueries from './useMediaQueries'
import { createViewportHelpers } from './utils'

const ViewportContext = createContext(null)

const ViewportProvider = ({ children, ssrViewport }) => {
  const currentViewport = useMediaQueries(ssrViewport)

  const viewportHelpers = useMemo(() => createViewportHelpers(currentViewport), [currentViewport])

  return <ViewportContext.Provider value={viewportHelpers}>{children}</ViewportContext.Provider>
}

export { ViewportProvider, ViewportContext }
